/** Trainingsdaten live aus der Datenbank (F-34). */
import { useEffect, useMemo } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { bibliothekSicherstellen } from '@/db/repositories/training';
import type { PlanEinheit, TrainingsPlan, Uebung } from '@/domain/training/typen';
import type { ID } from '@/domain/types';

/** Legt beim ersten Besuch die mitgelieferte Bibliothek an. */
export function useBibliothekBereit(): void {
  useEffect(() => { void bibliothekSicherstellen(); }, []);
}

export function useUebungen(): Uebung[] {
  return useLiveQuery(() => db.uebungen.orderBy('name').toArray(), [], []);
}

export function useUebungsMap(): Map<ID, Uebung> {
  const alle = useLiveQuery(() => db.uebungen.orderBy('name').toArray(), []);
  // Stabil, solange sich die Bibliothek nicht aendert - teure Auswertungen haengen daran.
  return useMemo(() => new Map((alle ?? []).map((u) => [u.id, u])), [alle]);
}

export function usePlaene(): TrainingsPlan[] | undefined {
  return useLiveQuery(() => db.trainingsplaene.toArray(), []);
}

export function usePlanEinheiten(planId: ID | undefined): PlanEinheit[] {
  return useLiveQuery(() => (planId ? db.planEinheiten.where('planId').equals(planId).toArray() : []), [planId], []);
}

export function useEinheit(id: ID | undefined): PlanEinheit | null | undefined {
  return useLiveQuery(async () => (id ? (await db.planEinheiten.get(id)) ?? null : null), [id]);
}

/** Alle Einheiten aller Plaene - fuer „Heute“ (die Version des Tages kann eine alte sein). */
export function useAlleEinheiten(): PlanEinheit[] {
  return useLiveQuery(() => db.planEinheiten.toArray(), [], []);
}
